'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AllowedIntents = {
  LEAD_FLOWS: 'LEAD_FLOWS',
  MEETINGS: 'MEETINGS'
};

exports.default = AllowedIntents;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/signup-ui-core/static-1.15/js/constants/AllowedIntents.js
// module id = 139
// module chunks = 0